import React from "react";
import { Form, InputNumber, Space, Switch, Typography } from "antd";
import { FormSection, SectionContainer } from "../styles";

const { Title } = Typography;

interface ShippingSectionProps {
  shippingRef: React.RefObject<HTMLDivElement>;
  useVariationShipping: boolean;
  onVariationShippingChange: (value: boolean) => void;
}

const ShippingSection: React.FC<ShippingSectionProps> = ({
  shippingRef,
  useVariationShipping,
  onVariationShippingChange,
}) => {
  return (
    <SectionContainer ref={shippingRef}>
      <FormSection>
        <Title level={4}>Vận chuyển</Title>

        <Form.Item
          label={<div>Cài đặt trọng lượng và kích thước cho mỗi phân loại</div>}
        >
          <Switch
            checked={useVariationShipping}
            onChange={onVariationShippingChange}
          />
        </Form.Item>

        {!useVariationShipping && (
          <>
            <Form.Item
              name="weight"
              label="Trọng lượng (Sau khi đóng gói)"
              rules={[
                { required: true, message: "Vui lòng nhập trọng lượng" },
                {
                  transform: (value) => Number(value),
                  type: "number",
                  message: "Vui lòng nhập số",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={1}
                precision={0}
                placeholder="Nhập trọng lượng"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) =>
                  Number(value!.replace(/\$\s?|(,*)/g, ""))
                }
              />
            </Form.Item>

            <Form.Item label="Kích thước gói">
              <Space>
                <Form.Item name="length" noStyle>
                  <InputNumber placeholder="Nhập chiều dài" min={0} precision={0} />
                </Form.Item>
                <Form.Item name="width" noStyle>
                  <InputNumber placeholder="Nhập chiều rộng" min={0} precision={0} />
                </Form.Item>
                <Form.Item name="height" noStyle>
                  <InputNumber placeholder="Nhập chiều cao" min={0} precision={0} />
                </Form.Item>
                <span>cm</span>
              </Space>
            </Form.Item>
          </>
        )}
      </FormSection>
    </SectionContainer>
  );
};

export default ShippingSection;